import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { MarketODataService, IProvider, ProviderODataService } from '@exchange/domain/.'
import { GridSize, GridWrapperComponent, MultiRowSelection } from 'common-components'
import { forkJoin } from 'rxjs'

@Component({
  selector: 'app-market-edit-providers',
  templateUrl: './market-edit-providers.component.html',
  standalone: false
})
export class MarketEditProvidersComponent implements OnInit {
  @ViewChild('available', { static: true }) available: GridWrapperComponent
  @ViewChild('selected', { static: true }) selected: GridWrapperComponent
  @Input() public set marketId(value: number) {
    this._marketId = value
    this.selected.defaultFilter = `MarketId eq ${value}`
  }

  GridSize = GridSize
  private _gridOptions = {
    canEdit: false,
    canDelete: false
  }
  private _marketId: number
  availableSelection: IProvider[] = []
  selectedSelection: IProvider[] = []

  constructor(
    private marketService: MarketODataService,
    private providerService: ProviderODataService
  ) {}

  ngOnInit() {
    this.marketService
      .query()
      .filter(`Id eq ${this._marketId}`)
      .orderBy('Name')
      .exec()

    this.providerService
      .query()
      .orderBy('Name')
      .exec()

    this.initializeAvailable()
    this.initializeSelected()

    this.selected.defaultFilter = `MarketId eq ${this._marketId}`
    this.selected.getData()
  }

  initializeAvailable() {
    this.available.defaultFilter = `IsAnchor eq true and MarketId eq null`
    this.available.gridOptions.context = this._gridOptions
    this.available.gridOptions.columnDefs = [
      {
        headerName: 'Id',
        field: 'Id',
        width: 50,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true, newRowsAction: 'keep' }
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.available.gridOptions.rowSelection = MultiRowSelection
    this.available.odata = this.providerService
    this.available.gridOptions.onSelectionChanged = this.recalculateSelected.bind(this)
  }

  initializeSelected() {
    this.selected.defaultFilter = `MarketId eq null`
    this.selected.gridOptions.context = this._gridOptions
    this.selected.gridOptions.columnDefs = [
      {
        headerName: 'Id',
        field: 'Id',
        width: 50,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true, newRowsAction: 'keep' }
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.selected.gridOptions.rowSelection = MultiRowSelection
    this.selected.odata = this.providerService
    this.selected.gridOptions.onSelectionChanged = this.recalculateSelected.bind(this)
  }

  fieldChanged(e): void {
    this.providerService
      .put(e.data, e.data.Id)
      .exec()
      .subscribe(result => {
        this.selected.getData()
      })
  }

  recalculateSelected() {
    this.availableSelection = this.available.api.getSelectedRows() as IProvider[]
    this.selectedSelection = this.selected.api.getSelectedRows() as IProvider[]
  }

  select() {
    const observables = this.availableSelection.map(item =>
      this.providerService.customAction(item.Id, 'Default.UpdateMarket', {
        marketId: this._marketId
      })
    )

    forkJoin(observables).subscribe(_ => {
      this.selected.getData()
      this.available.getData()
      setTimeout(this.recalculateSelected.bind(this), 250)
    })
  }

  remove() {
    const observables = this.selectedSelection.map(item =>
      this.providerService.customAction(item.Id, 'Default.UpdateMarket', null)
    )

    forkJoin(observables).subscribe(_ => {
      this.selected.getData()
      this.available.getData()
      setTimeout(this.recalculateSelected.bind(this), 250)
    })
  }
}
